import { render, staticRenderFns } from "./PresentationVitae.vue?vue&type=template&id=5941c5a6"
import script from "./PresentationVitae.vue?vue&type=script&lang=js"
export * from "./PresentationVitae.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports